import api from "./api";
import { AppResponse } from "../models/common/app-response";
import { LookupDto } from "../models/common/lookup.dto";

class EdoOperatorsService {
    baseUrl = "/api/v1/edo-operators";

    getList = () => api.get<AppResponse<LookupDto[]>>(this.baseUrl).then((r) => r.data.data);
}

export const edoOperatorsService = new EdoOperatorsService();
